import React, { useState, useEffect } from "react";
import { X, ChevronLeft, ChevronRight, ZoomIn } from "lucide-react";

const IMAGES = [
  {
    src: "/img/WhatsApp Image 2026-05-20 at 09.50.21.avif",
    alt: "Auto Socorro Pedrinho - Caminhão Plataforma Moderno",
    title: "Caminhão Plataforma de Última Geração",
    description: "Equipamento moderno e revisado para garantir um transporte 100% seguro do seu veículo."
  },
  {
    src: "/img/WhatsApp Image 2026-05-20 at 09.50.22.avif",
    alt: "Auto Socorro Pedrinho - Guincho e Reboque 24h",
    title: "Pronto para Atendimento Emergencial 24h",
    description: "Atendimento ágil em Arujá, na Rodovia Presidente Dutra e toda a região metropolitana."
  },
  {
    src: "/img/WhatsApp Image 2026-05-20 at 09.50.22 (1).avif",
    alt: "Auto Socorro Pedrinho - Equipamento de Alta Segurança",
    title: "Sinalização e Segurança Operacional",
    description: "Todos os procedimentos de segurança seguidos rigidamente para proteger seu patrimônio."
  },
  {
    src: "/img/WhatsApp Image 2026-05-20 at 09.50.22 (2).avif",
    alt: "Auto Socorro Pedrinho - Reboque Profissional",
    title: "Remoção de Veículos com Cuidado Extremo",
    description: "Atendemos carros de luxo, rebaixados, SUVs, utilitários e motocicletas com o mesmo rigor técnico."
  },
  {
    src: "/img/WhatsApp Image 2026-05-20 at 09.50.23.avif",
    alt: "Auto Socorro Pedrinho - Guincho de Carros e Utilitários",
    title: "Frota Preparada para Qualquer Chamado",
    description: "Nossos caminhões contam com plataformas hidráulicas modernas para embarque suave."
  },
  {
    src: "/img/WhatsApp Image 2026-05-20 at 09.50.24.avif",
    alt: "Auto Socorro Pedrinho - Atendimento de Rodovias",
    title: "Resgate Rápido na Rodovia Presidente Dutra",
    description: "Tempo de resposta recorde para tirar você e seu veículo da área de risco da rodovia."
  },
  {
    src: "/img/WhatsApp Image 2026-05-20 at 09.50.25.avif",
    alt: "Auto Socorro Pedrinho - Guincho em Arujá e Região",
    title: "Auto Socorro Pedrinho em Ação",
    description: "Sua melhor escolha em guincho perto de mim em Arujá, Santa Isabel e Mogi das Cruzes."
  },
  {
    src: "/img/WhatsApp Image 2026-05-20 at 09.50.25 (1).avif",
    alt: "Auto Socorro Pedrinho - Compromisso com o Cliente",
    title: "Equipe Altamente Treinada e Eficiente",
    description: "Profissionais experientes prontos para resolver sua emergência com agilidade e cordialidade."
  }
];

export function Gallery() {
  const [activeIndex, setActiveIndex] = useState(null);

  const openLightbox = (index) => {
    setActiveIndex(index);
    document.body.style.overflow = "hidden"; // Prevent background scroll
  };

  const closeLightbox = () => {
    setActiveIndex(null);
    document.body.style.overflow = ""; // Restore background scroll
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setActiveIndex((prev) => (prev === IMAGES.length - 1 ? 0 : prev + 1));
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setActiveIndex((prev) => (prev === 0 ? IMAGES.length - 1 : prev - 1));
  };

  // Keyboard navigation support
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (activeIndex === null) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") setActiveIndex((prev) => (prev === IMAGES.length - 1 ? 0 : prev + 1));
      if (e.key === "ArrowLeft") setActiveIndex((prev) => (prev === 0 ? IMAGES.length - 1 : prev - 1));
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [activeIndex]);

  return (
    <section className="section gallery-section" id="galeria" data-testid="gallery-section">
      <div className="section-heading" data-testid="gallery-heading">
        <span className="section-eyebrow">Nossa Frota em Ação</span>
        <h2>Galeria de Fotos do Caminhão</h2>
        <p>
          Conheça nosso equipamento real! Fotos reais do caminhão plataforma da Auto Socorro Pedrinho atendendo com excelência e cuidado absoluto em Arujá e rodovias.
        </p>
      </div>

      <div className="gallery-grid" data-testid="gallery-grid">
        {IMAGES.map((img, index) => (
          <div
            key={index}
            className="gallery-item-card group"
            onClick={() => openLightbox(index)}
            data-testid={`gallery-item-${index}`}
          >
            <div className="gallery-img-wrapper">
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="gallery-img"
              />
              <div className="gallery-hover-overlay">
                <div className="gallery-zoom-badge">
                  <ZoomIn size={20} />
                  <span>Ampliar Foto</span>
                </div>
              </div>
            </div>
            <div className="gallery-item-info">
              <h3>{img.title}</h3>
              <p>{img.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox Modal Popup */}
      {activeIndex !== null && (
        <div
          className="lightbox-overlay"
          onClick={closeLightbox}
          data-testid="lightbox-modal"
        >
          <button
            className="lightbox-close-btn"
            onClick={closeLightbox}
            aria-label="Fechar galeria"
          >
            <X size={26} />
          </button>

          <button
            className="lightbox-nav-btn prev"
            onClick={prevImage}
            aria-label="Imagem anterior"
          >
            <ChevronLeft size={36} />
          </button>

          <div className="lightbox-content-wrapper" onClick={(e) => e.stopPropagation()}>
            <img
              src={IMAGES[activeIndex].src}
              alt={IMAGES[activeIndex].alt}
              className="lightbox-main-img"
            />
            <div className="lightbox-caption-panel">
              <span className="lightbox-counter">
                Foto {activeIndex + 1} de {IMAGES.length}
              </span>
              <h3>{IMAGES[activeIndex].title}</h3>
              <p>{IMAGES[activeIndex].description}</p>
            </div>
          </div>

          <button
            className="lightbox-nav-btn next"
            onClick={nextImage}
            aria-label="Próxima imagem"
          >
            <ChevronRight size={36} />
          </button>
        </div>
      )}
    </section>
  );
}
